import React from "react";
import { MKT_GOLD, MKT_TINT } from "../../lib/marketplace";

export const soles = (n) => `S/ ${Number(n || 0).toFixed(2)}`;

export const PRESETS = [
  { key: "7d", label: "7 días", dias: 7 },
  { key: "30d", label: "30 días", dias: 30 },
  { key: "90d", label: "90 días", dias: 90 },
  { key: "365d", label: "1 año", dias: 365 },
];

export function rangoDesde(dias) {
  const hasta = new Date();
  const desde = new Date();
  desde.setDate(desde.getDate() - dias);
  return { desde: desde.toISOString(), hasta: hasta.toISOString() };
}

export function PeriodoSelector({ value, onChange }) {
  return (
    <div className="inline-flex rounded-xl border border-slate-200 bg-white p-1" data-testid="periodo-selector">
      {PRESETS.map((p) => (
        <button
          key={p.key}
          onClick={() => onChange(p.key)}
          data-testid={`periodo-${p.key}`}
          className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${value === p.key ? "text-white" : "text-slate-500 hover:text-slate-800"}`}
          style={value === p.key ? { backgroundColor: MKT_GOLD } : undefined}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}

export function StatKpi({ Icon, label, value, sub, color }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-soft" data-testid="stat-kpi">
      <div className="flex items-center gap-2 text-slate-500 text-xs font-semibold">{Icon && <Icon size={15} style={{ color }} />} {label}</div>
      <p className="mt-1.5 text-xl font-extrabold text-slate-900">{value}</p>
      {sub && <p className="text-[11px] text-slate-400 mt-0.5">{sub}</p>}
    </div>
  );
}

export function SerieBars({ serie }) {
  if (!serie || serie.length === 0) return <p className="text-sm text-slate-400 py-6 text-center">Sin ventas en el periodo.</p>;
  const max = Math.max(...serie.map((s) => s.ingreso), 1);
  return (
    <div className="flex items-end gap-1 h-40 overflow-x-auto pb-1" data-testid="serie-bars">
      {serie.map((s) => (
        <div key={s.fecha} className="flex flex-col items-center justify-end flex-1 min-w-[10px] group relative">
          <div className="w-full rounded-t transition-all group-hover:brightness-110" style={{ height: `${(s.ingreso / max) * 100}%`, backgroundColor: MKT_GOLD, minHeight: s.ingreso > 0 ? 4 : 0 }} />
          <span className="absolute -top-5 hidden group-hover:block text-[10px] font-bold text-slate-700 bg-white px-1 rounded shadow">{soles(s.ingreso)}</span>
        </div>
      ))}
    </div>
  );
}

export function Ranking({ titulo, items, label, valor }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-soft">
      <h3 className="font-bold text-slate-900 mb-3">{titulo}</h3>
      {(!items || items.length === 0) ? <p className="text-sm text-slate-400">Sin datos.</p> : (
        <ul className="space-y-2">
          {items.map((it, i) => (
            <li key={i} className="flex items-center justify-between text-sm">
              <span className="min-w-0 truncate text-slate-700 inline-flex items-center gap-2">
                <span className="w-5 h-5 rounded-md flex items-center justify-center text-[10px] font-bold" style={{ backgroundColor: MKT_TINT, color: MKT_GOLD }}>{i + 1}</span>
                {label(it)}
              </span>
              <span className="font-bold text-slate-800 flex-shrink-0">{valor(it)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
